// extracted by mini-css-extract-plugin
export default {"spinner":"spinner-XI9HhLST66O8Ca1QVpNo","mini":"mini-rbUhvCOpOvItRkiBdPjk","inner":"inner-xc683dOuS_I10KHRrv18","spin":"spin-vfP50XZOkPJKHLXUL_5a"};